import { useEffect } from 'react';
import { CheckCircleIcon, XMarkIcon, ExclamationTriangleIcon } from '@heroicons/react/24/outline';

export type ToastKind = 'success' | 'error' | 'info';

interface Props {
  kind: ToastKind;
  message: string;
  onClose: () => void;
  durationMs?: number;
}

const Toast = ({ kind, message, onClose, durationMs = 3000 }: Props) => {
  useEffect(() => {
    const t = setTimeout(onClose, durationMs);
    return () => clearTimeout(t);
  }, [onClose, durationMs]);

  const palette =
    kind === 'success'
      ? 'bg-green-600 text-white'
      : kind === 'error'
        ? 'bg-red-600 text-white'
        : 'bg-slate-700 text-white';

  const Icon = kind === 'success' ? CheckCircleIcon : kind === 'error' ? ExclamationTriangleIcon : CheckCircleIcon;

  return (
    <div className="fixed bottom-6 right-6 z-50">
      <div className={`flex items-center gap-3 rounded-xl px-4 py-3 shadow-xl ${palette}`}>
        <Icon className="h-5 w-5" />
        <div className="text-sm font-medium">{message}</div>
        <button type="button" onClick={onClose} className="ml-2 rounded p-1/2 hover:opacity-80">
          <XMarkIcon className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
};

export default Toast;

